import { FunctionComponent, PropsWithChildren, useEffect, useRef, useState } from "react";
import * as Styled from "./styles";

interface ScrollableContainerProps extends PropsWithChildren {
  name: string;
  paddingTop?: number;
}

const ScrollableContainer: FunctionComponent<ScrollableContainerProps> = ({
  name,
  children,
  ...props
}: ScrollableContainerProps) => {
  const [containerHeight, setContainerHeight] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const calculateContainerHeight = () => {
      const mainWrapper = document.querySelector("#main");
      const mainWrapperHeight = mainWrapper?.clientHeight || 645;
      const footer = document.getElementById("footer");

      const progressBarHeight = 0;
      const headerHeight = 72;
      const footerHeight = footer?.clientHeight || 0;
      const footerOffset = 30;
      // const footerOffset = 15;

      setContainerHeight(mainWrapperHeight - headerHeight - footerHeight - progressBarHeight - footerOffset);
    };
    calculateContainerHeight();
    window.addEventListener("resize", calculateContainerHeight);
    return () => window.removeEventListener("resize", calculateContainerHeight);
  }, [children]);

  return (
    <Styled.ScrollableContainerDiv
      data-name={name}
      data-testid={name}
      $height={containerHeight}
      ref={containerRef}
      {...props}
    >
      {children}
    </Styled.ScrollableContainerDiv>
  );
};

export default ScrollableContainer;
